require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /usr/src/site-blog/node_modules/core-js/modules/es7.symbol.async-iterator.js
// module id = 425
// module chunks = 99